import React, { useState, useEffect } from "react";
import { customerApi } from "../../api/client";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

export default function AccountProfile() {
  const [profile, setProfile] = useState({ name: "", email: "", phone: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    customerApi("/api/customer/me")
      .then((data) => setProfile({ name: data.name || "", email: data.email || "", phone: data.phone || "" }))
      .catch(() => setError("Failed to load profile"))
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);
    setSaving(true);
    try {
      await customerApi("/api/customer/me", {
        method: "PUT",
        body: JSON.stringify({ name: profile.name.trim(), phone: profile.phone.trim() }),
      });
      setSuccess(true);
    } catch (err) {
      setError(err.message || "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Typography>Loading…</Typography>;

  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
        Profile
      </Typography>
      {error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}
      {success && <Typography color="primary" sx={{ mb: 2 }}>Profile updated.</Typography>}
      <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 400, display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Name"
          value={profile.name}
          onChange={(e) => setProfile((p) => ({ ...p, name: e.target.value }))}
          fullWidth
          size="small"
        />
        <TextField label="Email" value={profile.email} fullWidth size="small" disabled />
        <TextField
          label="Phone"
          value={profile.phone}
          onChange={(e) => setProfile((p) => ({ ...p, phone: e.target.value }))}
          fullWidth
          size="small"
        />
        <Button type="submit" variant="contained" disabled={saving}>
          {saving ? "Saving…" : "Save"}
        </Button>
      </Box>
    </Box>
  );
}
